<template>
  <data-table
    table-name="invoicesDataTable"
    :tableData.sync="listData"
    :columns="columns"
    :multipleSelectionOperation="multipleSelectionOperation"
    :isMultipleSelectionShow = "isMultipleSelectionShow"
    @handleSelectionChange = "handleSelectionChange"
    :pageSize='100'
    :isPaginationShow="false"
  ></data-table>
</template>

<script>
  import DataTable from '../../components/DataTable'
  import { formatMoney } from '../../filters/CommonFilters'

  export default {
    name: "InvoicesDataTable",
    data() {
      return {

      }
    },
    props: {
      invoices: {
        type: Array,
        default: ()=>{
          return []
        },
      },
      columns: {
        type: Array,
        default: ()=>{
          return [
            {
              name: '单据类型',
              field: 'pi__invoiceType'
            },
            {
              name: '单据号码',
              field: 'pi__invoiceNo'
            },
            {
              name: '单据金额',
              field: 'pi__totalAmount',
            },
            {
              name: '质押金额',
              field: 'pi__pledgeAmount'
            },
            {
              name: '币种',
              field: 'pi__currencyCode',
              formatter: function(r,c,v) {
                return '人民币'
              }
            },
            {
              name: '单据日期',
              field: 'pi__invoiceDate',
            },
            {
              name: '到期日',
              field: 'pi__dueDate',
            },
            {
              name: '可融资金额',
              field: 'pi__balanceAmount',
            },
            {
              name: '本次融资金额',
              field: 'pi__financingAmount',
              component: 'el-input'
            },
          ]
        }
      },
      multipleSelectionOperation: {
        type: Array,
        default: ()=>{
          return []
        }
      },
      isMultipleSelectionShow: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      listData: {
        get() {
          return {
            data: this.invoices.filter(item=>item['pi__invoiceId'])
          }
        },
        set(newVal) {
          console.log(newVal)
        }
      }
    },
    components: {
      DataTable,
    },
    filters: {
      formatMoney
    },
    methods: {
      handleSelectionChange: function (val) {
        this.$emit('handleSelectionChange', val)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/InvoicesDataTable.vue